import React from 'react';
import {useTranslation, Trans} from 'react-i18next';
import wrongIcon from '../../../assets/something-wrong-icon.png';
import {Content, Description, Title} from '../styled';

function NotAvailable() {
  const {t} = useTranslation();

  return (
    <Content>
      <img src={wrongIcon} alt="successIcon" width={78} height={78} />
      <Title>{t('virtual_keys_not_available_title')}</Title>
      <Description>
        <Trans i18nKey="virtual_keys_not_available_description">
          The link for the virtual keys can only be used{' '}
          <b>within the date range of your booking.</b>
          <br />
          <br /> Please contact your host for further instructions.
        </Trans>
      </Description>
    </Content>
  );
}

export {NotAvailable};
